
"use strict";
var GroupFilterNames = exports.GroupFilterNames = ['and', 'or'];
var FilterTypes = exports.FilterTypes = {};
var FilterTypesList = exports.FilterTypesList = [
  {
    id: 'eq',
    symbol: '=',
    nsymbol: '<>',
    name: 'equals',
    template: {
      type: 'eq',
      field: "",
      negative: false,
      value: "",
      parent: null
    }
  },
  {
    id: 're',
    symbol: '~',
    nsymbol: '!~',
    noHaving: true,
    noSubFilter: true,
    name: 'matches',
    template: {
      type: 're',
      field: "",
      negative: false,
      value: "",
      parent: null
    }
  },
  {
    id: 'lt',
    symbol: '<',
    nsymbol: '>=',
    name: 'less than',
    noSubFilter: true,
    template: {
      type: 'lt',
      field: "",
      negative: false,
      value: "",
      parent: null
    }
  },
  {
    id: 'gt',
    symbol: '>',
    nsymbol: '<=',
    name: 'greater than',
    noSubFilter: true,
    template: {
      type: 'gt',
      field: "",
      negative: false,
      value: "",
      parent: null
    }
  },
  {
    id: 'bt',
    symbol: 'between',
    nsymbol: 'not between',
    name: 'between',
    noSubFilter: true,
    valuesLength: 2,
    template: {
      type: 'bt',
      field: "",
      negative: false,
      values: ["", ""],
      parent: null
    }
  },
  {
    id: 'in',
    symbol: 'in',
    nsymbol: 'not in',
    name: 'in',
    noSubFilter: true,
    template: {
      type: 'in',
      field: "",
      negative: false,
      values: [""],
      parent: null
    }
  },
  {
    id: 'and',
    symbol: 'and',
    name: 'and',
    isGrouping: true,
    template: {
      type: 'and',
      negative: false,
      parent: null,
      children: []
    }
  },
  {
    id: 'or',
    symbol: 'or',
    name: 'or',
    isGrouping: true,
    template: {
      type: 'or',
      negative: false,
      parent: null,
      children: []
    }
  }
]

var each = require('../../lib/deep-query-api/lib/collections').each;

each(FilterTypesList, function(type) { FilterTypes[type.id] = type; });

/*
{
  type: FilterTypeId
  field: <field>
  negative: <bool>
  value: <value>
  parent: <ref>
  children: [<ref>...]
}

*/
